module.exports = __webpack_public_path__ + "media/images/activity-indicator-light-3ba02ea526e7c7dfab005b0deb28f6b7.svg";